goog.provide('yext.location.ecl');
goog.provide('yext.location.ecl.EnhancedList');
goog.provide('yext.location.ecl.ListSelection');

goog.require('yext');
goog.require('yext.location.SearchableMultipleSelect');
goog.require('yext.textfield.TextField');
goog.require('yext.storm.routesDEPRECATED');
goog.require('yext.dialog');
goog.require('yext.textfield');


/**
 * @param {!jQuery} $ctx Element context for this field
 * @constructor
 * @author MattJS (matt@yext.com)
 */
yext.location.ecl.EnhancedList = function($ctx) {
  this.$ctx = $ctx;
  this.$field = $ctx.find('.js-enhanced-list-field').addBack().filter('.js-enhanced-list-field');
  this.$fieldValue = this.$field.find('.js-field-value');
  this.publishDialogTemplate = this.$field.find('.js-publish-ecl-dialog-template').html();

  this.fieldData = this.$field.data();

  this.label = yext.textfield.createWithUsageType($ctx, this.getFieldId());
  this.selectedLists = new yext.location.ecl.ListSelection($ctx, this.fieldData);

  this.setFieldValue();
  this.bind();
};

/**
 * Saves the state of the field
 */
yext.location.ecl.EnhancedList.prototype.saveState = function() {
  this.label.saveValue();
  this.selectedLists.storeValue();
};

/**
 * Get the field id for the field
 */
yext.location.ecl.EnhancedList.prototype.getFieldId = function() {
  return this.fieldData['fieldId'];
};

/**
 * Get the list type, which corresponds to EnhancedListsView.Type#getSlug
 */
yext.location.ecl.EnhancedList.prototype.getListType = function() {
  return this.fieldData['listType'];
};

/**
 * Maps the type slug to com.yext.enhancedlists.EnhancedList.Type enum
 */
yext.location.ecl.EnhancedList.prototype.getMappedListType = function() {
  return yext.location.ecl.EnhancedList.TYPE_MAP[this.getListType()];
};

yext.location.ecl.EnhancedList.TYPE_MAP = {
  'menus': 'Menu',
  'products': 'ProductList',
  'events': 'Calendar',
  'bios': 'Bios',
};

yext.location.ecl.EnhancedList.MAX_LIST_COUNT = 40;

/**
 * Sets a hidden input to the JSON value of this field
 */
yext.location.ecl.EnhancedList.prototype.setFieldValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.getData()));
};

/**
 * Get list data for saving
 */
yext.location.ecl.EnhancedList.prototype.getData = function() {
  return {
    'label': this.label.coreData(),
    'selectedLists': this.selectedLists.getData(),
  };
};

/**
 * Bind field events
 */
yext.location.ecl.EnhancedList.prototype.bind = function() {
  var self = this;

  $(this.label).on('update.textField', function() {
    self.updated();
  });

  $(this.selectedLists).on('updated', function() {
    self.updated();
  });

  this.$ctx.find('.js-hidden-list-badge').each(function() {
    self.bindShowListBadge($(this));
  });
};

/**
 * Bind the 'Show list' button for hidden lists
 */
yext.location.ecl.EnhancedList.prototype.bindShowListBadge = function($badge) {
  var self = this;
  var option = this.selectedLists.getOption($badge);

  $badge.contextualHelp({width: 160});

  $badge.click(function(e) {
    e.stopPropagation();
    $('.js-tooltip-publish-'+ self.getListType() + ' .js-publish-list').off().click(function() {
      window.hideContextualHelp();
      self.showList(option.value);
    });
  });
};

/**
 * Fetch the number of associated listings and then show a dialog to confirm 'publishing' the list
 *
 * @param {number} listId
 */
yext.location.ecl.EnhancedList.prototype.showList = function(listId) {
  var self = this;
  this.fetchAssociatedLocationCount(listId, function(count) {
    self.showPublishDialog(listId, count);
  }, function() {
    self.errorShowingList();
  });
};

/**
 * Error message for 'show' operation
 */
yext.location.ecl.EnhancedList.prototype.errorShowingList = function() {
  // TRANSLATORS: 'list' is a Yext Enhanced Content List
  yext.dialog.showErrorDialog(yext.msg('Error showing list'));
};

/**
 * Get the number of listings that have this list associated
 * @param {number} listId
 * @param {function()} cb Triggered after the ajax call returns with a count
 * @param {function()} error
 */
yext.location.ecl.EnhancedList.prototype.fetchAssociatedLocationCount = function(listId, cb, error) {
  var data = {
    'ids': [listId],
    'type': this.getMappedListType(),
  };

  $.ajax({
    url: yext.storm.routesDEPRECATED.EnhancedLists.countAssociatedLocations(),
    data: data,
    success: function(response) {
      if (response && response['total']) {
        cb(response['total']);
      } else {
        error();
      }
    },
    error: function() {
      error();
    },
  });
};

/**
 * Show the publish list dialog and bind its actions
 * @param {number} listId
 * @param {number} count The number of locations with this list associated
 */
yext.location.ecl.EnhancedList.prototype.showPublishDialog = function(listId, count) {
  var self = this;
  var $dialog = this.buildPublishDialog(count);
  $dialog.find('.js-do-publish').click(function() {
    $dialog.dialog('close');
    self.publishList(listId);
  });
  $dialog.find('.js-cancel-publish').click(function() {
    $dialog.dialog('close');
  });
  $dialog.dialog('open');
};

/**
 * Makes a 'Hidden' list 'published'
 * @param {number} listId
 */
yext.location.ecl.EnhancedList.prototype.publishList = function(listId) {
  var self = this;

  yext.dialog.showProgressDialog(yext.msg('Showing...'));

  $.ajax({
    url: yext.storm.routesDEPRECATED.EnhancedLists.publishLists(),
    data: {
      'publish': true,
      'ids': [listId],
      'type': this.getMappedListType(),
    },
    method: 'POST',
    success: function(result) {
      if (result && result.result === 'success') {
        self.removeHiddenBadge(listId);
      } else if (result && result.reason) {
        yext.dialog.showErrorDialog(result.reason);
      } else {
        self.errorShowingList();
      }
    },
    error: function() {
      self.errorShowingList();
    },
  }).always(function() {
    yext.dialog.hideProgressDialog();
  });
};

/**
 * Removes the 'Hidden' badge from a recently published list
 * @param {number} listId
 */
yext.location.ecl.EnhancedList.prototype.removeHiddenBadge = function(listId) {
  var $option = this.selectedLists.getOptionElement(listId);
  var $displayOption = this.selectedLists.getOptionDisplayElement(listId);

  $option.find('.js-hidden-list-badge').remove();
  $displayOption.find('.js-hidden-list-badge').remove();
};

/**
 * Build the publish dialog by getting the correct copy based upon listType
 * @param {number} count The number of locations associated with a particular list
 */
yext.location.ecl.EnhancedList.prototype.buildPublishDialog = function(count) {
  var message;
  var title;

  switch (this.getListType()) {
    case 'menus':
      if (count === 0) {
        message = yext.msg(
          'This menu is hidden.<br><br>When you show this menu, it will appear on your listings immediately.');
      } else {
        message = yext.msgn(
          'This menu is associated with 1 location.<br><br>When you show it, it will appear on the listings for that location.',
          'This menu is associated with {0} locations.<br><br>When you show it, it will appear on the listings for those locations.',
          count);
      }
      title = yext.msg('Show menu');
      break;
    case 'events':
      if (count === 0) {
        message = yext.msg(
          'This calendar is hidden.<br><br>When you show this calendar, it will appear on your listings immediately.');
      } else {
        message = yext.msgn(
          'This calendar is associated with 1 location.<br><br>When you show it, it will appear on the listings for that location.',
          'This calendar is associated with {0} locations.<br><br>When you show it, it will appear on the listings for those locations.',
          count);
      }
      title = yext.msg('Show calendar');
      break;
    default:
      if (count === 0) {
        message = yext.msg(
          'This list is hidden.<br><br>When you show this list, it will appear on your listings immediately.');
      } else {
        message = yext.msgn(
          'This list is associated with 1 location.<br><br>When you show it, it will appear on the listings for that location.',
          'This list is associated with {0} locations.<br><br>When you show it, it will appear on the listings for those locations.',
          count);
      }
      title = yext.msg('Show list');
      break;
  }

  var $dialog = $(this.publishDialogTemplate.replace('{{MESSAGE}}', message));

  return $dialog.dialog({
    autoOpen: true,
    modal: true,
    draggable: false,
    resizable: false,
    title: title,
    width: 355,
    close: function() {
      $dialog.dialog('destroy');
    },
  });
};

/**
 * Called when any part of the field is updated
 */
yext.location.ecl.EnhancedList.prototype.updated = function() {
  this.setFieldValue();
  this.message('updated');
};

/**
 * Trigger a message that is broadcast with the instance as context
 * @param
 */
yext.location.ecl.EnhancedList.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Reset the state of the field to a stored state
 */
yext.location.ecl.EnhancedList.prototype.reset = function() {
  this.label.reset();
  this.selectedLists.reset();
};

/**
 * Set the value of the field
 */
yext.location.ecl.EnhancedList.prototype.set = function(field) {
  this.label.set(field['label']);
  this.selectedLists.set(field['selectedLists']);
};

/**
 * Renders the display mode. $ctx must contain the display mode
 */
yext.location.ecl.EnhancedList.prototype.renderDisplay = function() {
  this.$ctx.find('.js-display-options-container').html(this.selectedLists.getDisplayValue());
  this.$ctx.find('.js-list-label-display').html(this.label.viewMarkup());
};

/**
 * Extend SearchableMultipleSelect to provide some customization
 *
 * @param {!jQuery} $ctx Element context for this field
 * @param {boolean} fieldData Info about the field
 * @constructor
 */
yext.location.ecl.ListSelection = function($ctx, fieldData) {
  this.fieldData = fieldData;
  this.$deleteWarning = $ctx.find('.js-delete-warning').remove().show();

  // Call parent constructor
  yext.location.SearchableMultipleSelect.call(this, $ctx);
};
goog.inherits(yext.location.ecl.ListSelection, yext.location.SearchableMultipleSelect);

/**
 * Render the current state of the model
 */
yext.location.ecl.ListSelection.prototype.render = function() {
  yext.location.ecl.ListSelection.superClass_.render.call(this);
  this.checkSearcherCount();
};

/**
 * Any render that needs to happen after an update
 * @param {boolean} showAddMore
 */
yext.location.ecl.ListSelection.prototype.toggleAddMore = function(showAddMore) {
  this.$ctx.find('.js-add-option').toggle(showAddMore);
  this.$ctx.find('.js-max-per-location').toggle(!showAddMore);
};

/**
 * Add an empty search item to the end of the list
 */
yext.location.ecl.ListSelection.prototype.addSearchItem = function() {
  yext.location.ecl.ListSelection.superClass_.addSearchItem.call(this);
  this.checkSearcherCount();
};

/**
 * Add an empty search item to the end of the list
 */
yext.location.ecl.ListSelection.prototype.renderOption = function($option, option) {
  // Override the default behavior to be nothing
};

/**
 * Triggered when a searcher or option is deleted
 * @param {!jQuery} $li The list item being removed
 */
yext.location.ecl.ListSelection.prototype.onDeleteOption = function($li) {
  var self = this;

  if ($li.hasClass('js-option')) {
    var $eclOption = $li.find('.js-ecl-option');
    if ($eclOption.data('deleteWarning')) {
      this.showDeleteWarning($li);
      return;
    }
  }

  this.onDeleteOptionInternal($li);
};

yext.location.ecl.ListSelection.prototype.onDeleteOptionInternal = function($li) {
  var $checkbox = $li.find('[type=checkbox]');
  var option = this.optionsByValue[$checkbox.val()];
  var index = this.model.options.indexOf(option);

  if (index !== -1) {
    this.model.options.splice(index, 1);
  }

  $li.remove();

  this.onUpdate();
  this.checkSearcherCount();
};

/**
 * Show the delete warning dialog
 * @param {function()} onDelete Method to be called if the user chooses to delete
 */
yext.location.ecl.ListSelection.prototype.showDeleteWarning = function($li) {
  var self = this;

  this.$deleteWarning.find('.js-cancel-delete').off().click(function() {
    self.$deleteWarning.dialog('close');
  });

  this.$deleteWarning.find('.js-do-delete').off().click(function() {
    self.onDeleteOptionInternal($li);
    self.$deleteWarning.dialog('close');
  });

  this.$deleteWarning.dialog({
    autoOpen: true,
    modal: true,
    draggable: false,
    resizable: false,
    width: 400,
    title: this.$deleteWarning.data('title'),
  });
};

/**
 * Returns count of selected options
 * @return {number}
 */
yext.location.ecl.ListSelection.prototype.size = function() {
  return this.model.options.length;
};

/**
 * Get the current state of the field as a JSON string
 *
 * @return {string} JSON string of field
 */
yext.location.ecl.ListSelection.prototype.getData = function() {
  var selected = [];
  for (var i = 0; i < this.model.options.length; i++) {
    if (this.model.options[i].selected) {
      selected.push(this.model.options[i].getDataForExport());
    }
  }
  return {
    'options': selected,
    'numElided': this.model.numElided,
  };
};

/**
 * Checks the count of searchers and options and toggles the add more link
 */
yext.location.ecl.ListSelection.prototype.checkSearcherCount = function() {
  var searcherCount = this.$options.find('.js-search-options').length;
  var showAddMore = searcherCount + this.size() < yext.location.ecl.EnhancedList.MAX_LIST_COUNT;
  this.toggleAddMore(showAddMore);
};

/**
 * Parse the selected option, do NOT remove HTML tags
 *
 * @param {!Object} Details about the selected option
 * @return {string} Label to display
 *
 * Note (blin): parent parseSelectionlabel() method in multipleselect.js DOES strip away HTML, resulting in unstyled label
 */
yext.location.ecl.ListSelection.prototype.parseSelectionLabel = function(selection) {
  return this.formatLabel(selection.value, selection.label);
};

/**
 * Helper method to format ECL multiple select links (context: FL-1781)
 *
 * @param {number} id - Enhanced list item id
 * @param {string} name - Enhanced list item name
 * @return {string} label - Formatted enhanced item label text
 */
yext.location.ecl.ListSelection.prototype.formatLabel = function(id, name) {
  var label;

  if (this.fieldData['canViewLists']) {
    label =
      '<a href="/s/' + yext.businessId + '/' + this.fieldData['listType'] + '/' + id + '"' +
      ' class="enhancedList-link">' + name + '</a>';
  } else {
    label = '<span class="enhancedList-link">' + name + '</span>';
  }
  return label;
};

/**
 * Template a new option
 * @param {number} id - Enhanced list id
 * @param {string} name - Enhanced list name
 */
yext.location.ecl.ListSelection.prototype.templateNewOption = function(id, name) {
  var label = this.formatLabel(id, name);

  return $(this.optionTemplate
    .replace('#VALUE#', id)
    .replace('#LABEL#', label));
};
